import React, { Fragment, Component } from 'react';

import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { UncontrolledTooltip } from 'reactstrap';

import { connect } from 'react-redux';

import { setSidebarToggleMobile } from '../../reducers/ThemeOptions';

class SidebarHeader extends Component {
  toggleSidebarMobile = () => {
    let { sidebarToggleMobile, setSidebarToggleMobile } = this.props;
    setSidebarToggleMobile(!sidebarToggleMobile);
  };

  toggleSidebar = () => {
    let { sidebarToggle, setSidebarToggle } = this.props;
    setSidebarToggle(!sidebarToggle);
  };
  render() {
    let { sidebarToggleMobile } = this.props;
    return (
      <Fragment>
        <div className="app-sidebar--header">
          <div className="nav-logo">
            <Link
              to="/DashboardHome"
              title="Tend Admin Dashboard">
              {/* <i>
                <img
                  alt="Bamburgh React Admin Dashboard with Reactstrap PRO"
                  src={projectLogo}
                />
              </i> */}
              <span>Tend Admin Dashboard</span>
            </Link>
          </div>
          <button
            onClick={this.toggleSidebar}
            className="btn btn-sm collapse-sidebar-btn"
            id="CollapseSidebarTooltip">
            <FontAwesomeIcon icon={['far', 'dot-circle']} size="lg" />
          </button>
          <UncontrolledTooltip
            target="CollapseSidebarTooltip"
            container=".app-sidebar"
            placement="right">
            Collapse sidebar
          </UncontrolledTooltip>
          <button
            className={clsx(
              'navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn',
              { 'is-active': sidebarToggleMobile }
            )}
            onClick={this.toggleSidebarMobile}>
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
          <button
            onClick={this.toggleSidebar}
            className="expand-sidebar-btn btn btn-sm"
            id="ExpandSidebarTooltip">
            <FontAwesomeIcon icon={['fas', 'arrows-alt-h']} />
          </button>
          <UncontrolledTooltip
            target="ExpandSidebarTooltip"
            container=".app-sidebar"
            placement="right">
            Expand sidebar
          </UncontrolledTooltip>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarHeader);
